'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { isInIframe } from '@layerswap/utils/common';
export const SettingsStateContext = React.createContext(null);
export const SettingsProvider = ({ children, initialLayerswapData, initialSettings: initialSettings = {} }) => {
    const value = {
        settings: initialLayerswapData,
        initialSettings: mapLegacySettings(initialSettings),
        isEmbedded: false,
    };
    const [embedded, setEmbedded] = useState(false);
    useEffect(() => {
        setEmbedded(isInIframe());
    }, []);
    return (_jsx(SettingsStateContext.Provider, { value: { ...value, isEmbedded: embedded }, children: children }));
};
export function useSettingsState() {
    const data = React.useContext(SettingsStateContext);
    if (data === undefined) {
        throw new Error('useSettingsState must be used within a SettingsProvider');
    }
    return {
        ...data.settings,
        isEmbedded: data.isEmbedded,
    };
}
export function useInitialSettings() {
    const data = React.useContext(SettingsStateContext);
    if (data === undefined) {
        throw new Error('useInitialSettings must be used within a SettingsProvider');
    }
    return data.initialSettings;
}
function mapLegacySettings(params) {
    return {
        ...params,
        ...(params.destAddress ? { destination_address: params.destAddress } : {}),
        ...(params.fromExchange ? { from: params.fromExchange } : {}),
        ...(params.sourceExchangeName ? { from: params.sourceExchangeName } : {}),
        ...(params.destNetwork ? { to: params.destNetwork } : {}),
        ...(params.lockExchange ? { lockFrom: params.lockExchange } : {}),
        ...(params.lockNetwork ? { lockTo: params.lockNetwork } : {}),
        ...(params.addressSource ? { appName: params.addressSource } : {}),
        ...(params.asset ? { [params.to ? "toAsset" : "fromAsset"]: params.asset } : {}),
        ...(params.lockAsset ? { [params.to ? "lockToAsset" : "lockFromAsset"]: params.lockAsset } : {}),
    };
}
